//入力情報確認
import { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IFormInputs } from './RegisterUser';
import { HttpPostData, JumpPage } from '../../common/Util';
import { ResponseParamBase } from '../../common/Types';
import { TitleParamContext } from "../../context/TitleContext";
import { RegisterPageContext } from "../../context/RegisterPageTypeContext";
import market from  "../../css/market.module.scss";
import base from "../../css/base.module.css";
import confirm from "../../css/confirm.module.css";

export type ResponseParam = ResponseParamBase & {
    
}

export const Confirm = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const titleContext = useContext(TitleParamContext);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const userData = location.state as IFormInputs;
    const registerPageTypeContext = useContext(RegisterPageContext);

    useEffect(
        () => {
            titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "サポート会員情報", secondSubTitle: "（確認）" });
        },[]
    );

    return (
        <>
            <section className={market.marketArea}>
                <p style={{ marginLeft: "50px" }} className={base.messageFont}>以下の内容で仮登録を行います。</p>
            <section className={confirm.OutSideArea} style={{ marginTop:0 }}>
                <div className={confirm.InSideArea}>
                    <h1>登録内容</h1>
                    <h2>利用者（会社名または個人名）</h2>
                        <h3>{userData.userName}</h3>
                    <h2>メールアドレス</h2>
                        <h3>{userData.eMail}</h3>
                    <h2>パスワード</h2>
                    <h3>**********</h3>
                    <h2></h2>
                        <h3>{errorMessage}</h3>
                </div>
            </section>
                <div className={market.marketFooterArea} style={{ marginBottom: "100px" }}>
                    <button className={market.marketBackButton} type="button" onClick={(e) => { JumpPage<IFormInputs>("/ConsentForm/RegisterUser", { confirmPassword: userData.confirmPassword, eMail: userData.eMail, userName: userData.userName, password: userData.password }, "", navigate); }}>戻る</button>
                <button className={market.marketButton} type="submit" disabled={isLoading} onClick={async (e) => {
                    await HttpPostData<ResponseParam>("/userregister/sendregisermail", {
                        Email: userData.eMail, username: userData.userName,
                        password: userData.password, ConfirmPassword: userData.confirmPassword,
                        RegisterPageType: registerPageTypeContext.registerPageInfo.registerPageType
                    }, setIsLoading)
                        .then(response => {
                            if (response.status == 200 && response.data.resultFlg) {
                                JumpPage("Complete", response.data, "", navigate);
                            } else {
                                setErrorMessage(response.data.message);
                            }
                            return response.data;
                        })
                        .catch(error => {
                            setErrorMessage("メールの送信時にエラーが発生しました。");
                        });
                }}>仮登録</button>
                <button style={{ visibility: "hidden" }} className={market.marketBackButton}>次へ</button>
                </div>
            </section>
        </>
    );
}